import { atom } from "jotai";

export const notifAtom = atom([]);
export const unReadNotifAtom = atom(0);
export const pageAtom = atom(1);
export const lastPageAtom = atom(0);
export const sizePerPageAtom = atom(10);
export const totalSizeAtom = atom(10);
